import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getCbp } from "../redux/cbpSlice";
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Cbp = () => {
    const dispatch = useDispatch();
    const { data: cbp = [], status } = useSelector((state) => state.cbp);
    const cbpWithoutFirst = Array.isArray(cbp) ? cbp.slice(1) : [];
    // external arrow controls
    const sliderRef = useRef(null);
    const [isBlank, setIsBlank] = useState(false);

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnHover: false,
        pauseOnFocus: false,
        arrows: false,
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1
    };

    const attributes = [
        { label: "Curated Deals", field: "curated_deals" },
        { label: "End-to-End Support", field: "end_to_end_support" },
        { label: "Group Investment", field: "group_investment" },
        { label: "Due Dilligence", field: "due_diligence" },
        { label: "Confidentiality", field: "confidentiality" },
        { label: "Pre Scrutiny", field: "pre_scrutiny" },
        { label: "Bespoke Deals", field: "bespoke_deals" },
        { label: "Range of Asset Classes", field: "range_of_asset_classes" },
        { label: "Collective Wisdom", field: "collective_wisdom" },
    ];

    useEffect(() => {
        if (status === 'idle') {
            dispatch(getCbp(1));
        }
    }, [dispatch, status]);

    return (
        <div className="row">
            <div className="col-12">
                <div className="d-flex align-items-center justify-content-center position-relative">
                    <h2 className='heading mb-3 mt-3 mb-md-4 mb-lg-4 mb-xl-4 mt-md-4 mt-lg-4 mt-xl-4'>Why Choose CBP?</h2>
                </div>
            </div>
            <div className="col-12 ps-3 pe-3">
                {/* Desktop View: Static Columns without Slider */}
                <div className="container">
                    <div className='row justify-content-center d-none d-md-flex'>
                        <div className='col-12 col-lg-12'>
                            <div className='row justify-content-center g-2'>
                                <div className='col cbp-fixed-left'>
                                    <ul className='list-unstyled'>
                                        <li className="d-flex justify-content-center">Features</li>
                                        {attributes.map(attr => (
                                            <li key={attr.field} className="d-flex justify-content-center">{attr.label}</li>
                                        ))}
                                    </ul>
                                </div>
                                <div className='col cbp-fixed-left'>
                                    <ul className='list-unstyled'>
                                        <li className="d-flex justify-content-center">Catalyst</li>
                                        {attributes.map(attr => (
                                            <li key={attr.field} className="d-flex justify-content-center align-items-center">
                                                <img src="/images/lets-icons_check-fill.svg" className="img-fluid" alt="Check" />
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                {status === 'loading' && <div className="col-auto"><p>Loading...</p></div>}
                                {status === 'failed' && <div className="col-auto"><p>Failed to load cbp.</p></div>}
                                {status === 'succeeded' && cbpWithoutFirst.map((item) => (
                                    <div key={item.cbp_id} className='col cbp-fixed-left'>
                                        <ul className="list-unstyled">
                                            <li className="d-flex justify-content-center">{item.feature}</li>
                                            {attributes.map(({ field }) => {
                                                const isTrue = String(item[field]).toLowerCase() === "true";
                                                return (
                                                    <li key={field} className="d-flex justify-content-center align-items-center">
                                                        {isTrue ? (
                                                            <img src="/images/lets-icons_check-fill.svg" className="img-fluid" alt="Check" />
                                                        ) : (
                                                            <img src="/images/mdi_cross-circle.svg" className="img-fluid" alt="Cross" />
                                                        )}
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                {/* Mobile View: With Slider */}
                <div className='row justify-content-center d-md-none'>
                    <div className='col-12'>
                        <div className='row justify-content-center g-1'>
                            <div className='col-6 cbp-fixed-left pe-1'>
                                <ul className='list-unstyled'>
                                    <li className="d-flex justify-content-center">Features</li>
                                    {attributes.map(attr => (
                                        <li key={attr.field} className="d-flex justify-content-center">{attr.label}</li>
                                    ))}
                                </ul>
                            </div>
                            <div className='col-6 cbp-fixed-right ps-1'>
                                {status === 'loading' && <p>Loading...</p>}
                                {status === 'failed' && <p>Failed to load cbp.</p>}
                                {status === 'succeeded' && cbp.length === 0 && <p>No cbp available.</p>}
                                {status === 'succeeded' && cbp.length > 0 && (
                                    <div className={isBlank ? 'fade-hidden' : ''}>
                                        <Slider ref={sliderRef} {...settings}>
                                            {cbp.map((item) => (
                                                <div key={item.cbp_id}>
                                                    <ul className="list-unstyled">
                                                        <li className="d-flex justify-content-center">{item.feature}</li>
                                                        {attributes.map(({ field }) => {
                                                            const isTrue = String(item[field]).toLowerCase() === "true";
                                                            return (
                                                                <li key={field} className="d-flex justify-content-center align-items-center">
                                                                    {isTrue ? (
                                                                        <img src="/images/lets-icons_check-fill.svg" className="img-fluid" alt="Check" />
                                                                    ) : (
                                                                        <img src="/images/mdi_cross-circle.svg" className="img-fluid" alt="Cross" />
                                                                    )}
                                                                </li>
                                                            );
                                                        })}
                                                    </ul>
                                                </div>
                                            ))}
                                        </Slider>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className="col-md-12 col-sm-12 col-lg-12 col-xl-12 ps-3 pe-3 d-none d-md-block d-lg-block d-xl-block">
                <div className='container p-0'>
                    <div className="row">
                        <div className='col-3 col-md-3 col-lg-3 cbp-fixed-left'>
                            <ul className='list-unstyled'>
                                <li>Features</li>
                                <li>Curated Deals</li>
                                <li>End-to-End Support</li>
                                <li>Group Investment</li>
                                <li>Due Dilligence</li>
                                <li>Confidentiality</li>
                                <li>Pre Scrutiny</li>
                                <li>Bespoke Deals</li>
                                <li>Range of Asset Classes</li>
                                <li>Collective Wisdom</li>
                            </ul>
                        </div>
                        {status === 'loading' && <p>Loading...</p>}
                        {status === 'failed' && <p>Failed to load cbp.</p>}
                        {status === 'succeeded' && cbp.length === 0 && <p>No cbp available.</p>}
                        {status === 'succeeded' && cbp.length > 0 && (
                            cbp.map((item) => (
                                <div className='col-3 col-md-3 col-lg-3 cbp-fixed-right' key={item.cbp_id}>
                                    <ul className="list-unstyled">
                                        <li>{item.feature}</li>
                                        {attributes.map(({ label, field }) => {
                                            const isTrue = String(item[field]).toLowerCase() === "true";
                                            return (
                                                <li key={field} className="d-flex justify-content-center align-items-center">
                                                    {isTrue ? (
                                                        <img src="/images/lets-icons_check-fill.svg" className="img-fluid" />
                                                    ) : (
                                                        <img src="/images/mdi_cross-circle.svg" className="img-fluid" />
                                                    )}
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div> */}
        </div >
    );
};

export default Cbp;